export default class User {
    constructor(id, firstName, lastName, dateOfBirth, medicareNumber,  accessLevel, isDependent, email, hcnIssuer) {
        this.id = id;
        this.firstName = firstName;
        this.lastName = lastName;
        this.dateOfBirth = dateOfBirth;
        this.medicareNumber = medicareNumber;
        this.accessLevel = accessLevel;
        this.isDependent = isDependent;
        this.email = email;
        this.hcnIssuer = hcnIssuer;
    }
}
